export default function HeroSection() {
  const scrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[720px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-accent-500/6 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-primary-500/5 blur-3xl"></div>
      </div>

      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-14 pt-20 md:pt-24">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-flashlight-line text-sm"></i>
              每日更新 · 极速播放
            </span>

            <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-black text-foreground-950 leading-tight mb-4">
              天堂影院
              <span className="block text-foreground-700 font-bold text-lg md:text-2xl lg:text-3xl mt-2">
                高清电影在线看
              </span>
            </h1>

            <p className="text-accent-500 font-heading text-base md:text-lg font-semibold mb-5">
              无广告 · 不缓冲 · 畅享观影
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed max-w-[560px] lg:max-w-none mb-6">
              天堂影院汇聚海量高清电影资源，涵盖最新电影在线观看、电影大全、经典老片与热门大片。
              所有影片高清不缓冲，极速加载流畅播放，无任何广告打扰，让每一次观影都成为纯粹的享受。
              无论您是动作片爱好者、悬疑片发烧友，还是想找一部温馨的动画片与家人共享，
              天堂影院都是您畅享高清影视在线的理想之选。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">20000+</div>
                <div className="text-xs text-foreground-400 mt-0.5">高清影片</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">每日更新</div>
                <div className="text-xs text-foreground-400 mt-0.5">片源实时同步</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-primary-500 font-heading">4K 超清</div>
                <div className="text-xs text-foreground-400 mt-0.5">多线路切换</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => scrollTo(e, '#index')}
                className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-play-circle-line mr-1.5"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => scrollTo(e, '#ranking')}
                className="w-full sm:w-auto px-7 py-3 rounded-md border border-background-300 text-foreground-600 font-medium text-sm hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer whitespace-nowrap text-center"
              >
                <i className="ri-fire-line mr-1.5"></i>
                查看热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full lg:max-w-[520px]">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20dark%20theme%20with%20film%20reel%2C%20theater%20spotlights%2C%20golden%20warm%20light%20accents%20on%20deep%20charcoal%20background%2C%20elegant%20cinema%20atmosphere%2C%20no%20text%2C%20artistic%20composition%2C%20dramatic%20lighting%2C%20movie%20poster%20aesthetic%20blended%20with%20abstract%20geometric%20elements%2C%20premium%20film%20festival%20visual%20style&width=1040&height=780&seq=hero-main-visual-01&orientation=landscape"
                alt="天堂影院 · 高清电影在线看"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 flex items-center gap-2">
                <span className="px-2.5 py-1 rounded-md bg-background-50/70 backdrop-blur-sm text-xs text-foreground-600 font-medium">
                  <i className="ri-hd-line mr-1 text-primary-500"></i>
                  4K 超清画质
                </span>
                <span className="px-2.5 py-1 rounded-md bg-background-50/70 backdrop-blur-sm text-xs text-foreground-600 font-medium">
                  <i className="ri-speed-up-line mr-1 text-accent-500"></i>
                  极速加载
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}